const hatsAndHairFilters = [
    {
        filterDisplayName: "Style",
        subFilters: [
            {
                filterDisplayName: "Short",
                filterType: "collection",
                filterHandle: "short-hair",
            },
            {
                filterDisplayName: "Mid Length",
                filterType: "collection",
                filterHandle: "mid-length-hair",
            },
            {
                filterDisplayName: "Long",
                filterType: "collection",
                filterHandle: "long-hair",
            },
            {
                filterDisplayName: "Ponytail",
                filterType: "collection",
                filterHandle: "ponytails-and-updos",
            },
            {
                filterDisplayName: "Plaits & Braids",
                filterType: "collection",
                filterHandle: "plaits-and-braids",
            },
            {
                filterDisplayName: "Buns & Up Dos",
                filterType: "collection",
                filterHandle: "buns-and-up-dos",
            },
            {
                filterDisplayName: "Curly & Wavy",
                filterType: "collection",
                filterHandle: "curly-and-wavy-hair",
            },
            {
                filterDisplayName: "Ears",
                filterType: "collection",
                filterHandle: "hair-with-pointy-ears",
            },
        ],
    },
    {
        filterDisplayName: "Hair colour",
        subFilters: [
            {
                filterDisplayName: "Grey & White",
                filterType: "collection",
                filterHandle: "grey-and-white-hair",
            },
            {
                filterDisplayName: "Blonde",
                filterType: "collection",
                filterHandle: "all-blonde-hair",
            },
            {
                filterDisplayName: "Ginger",
                filterType: "collection",
                filterHandle: "all-ginger-hair",
            },
            {
                filterDisplayName: "Red",
                filterType: "collection",
                filterHandle: "red-hair",
            },
            {
                filterDisplayName: "Brown",
                filterType: "collection",
                filterHandle: "all-brown-hair",
            },
            {
                filterDisplayName: "Black",
                filterType: "collection",
                filterHandle: "black-hair",
            },
            {
                filterDisplayName: "Bright",
                filterType: "collection",
                filterHandle: "funky-hair",
            },
        ],
    },
    {
        filterDisplayName: "Hats",
        filterType: "collection",
        filterHandle: "hats",
        subFilters: false,
    },
]

export { hatsAndHairFilters }
